import { useAppSelector } from "store/hooks"
import { ContractorUserRole } from "types/ContractorUserEnum"
import { ReactComponent as IconDevice } from "assets/svg/icon-device.svg"
import { ReactComponent as IconAlerts } from "assets/svg/menu-alerts.svg"
import { ReactComponent as IconCustomers } from "assets/svg/menu-customers.svg"
import { ReactComponent as IconDashboard } from "assets/svg/menu-dashboard.svg"
import { ReactComponent as IconIntelligenceReports } from "assets/svg/menu-intelligence.svg"
import { ReactComponent as IconMessages } from "assets/svg/menu-messages.svg"
import { ReactComponent as IconMonitoring } from "assets/svg/menu-monitoring.svg"
import { ReactComponent as IconOrders } from "assets/svg/menu-orders.svg"
import { ReactComponent as IconPerformance } from "assets/svg/menu-performance.svg"

import { useNewOrdersQuantity } from "hooks/useNewOrdersQuantity"

import { MenuBadge, MenuItem } from ".."

export const ContractorMenu = () => {
  const userProfile = useAppSelector(state => state.user.userProfile)
  const isTechnician = userProfile?.type === ContractorUserRole.TECHNICIAN
  const { data } = useNewOrdersQuantity({ enabled: !isTechnician })

  return (
    <>
      {!isTechnician && <MenuItem to="/mydashboard" icon={<IconDashboard />} label="Dashboard" />}
      {!isTechnician && <MenuItem to="/devices" icon={<IconDevice />} label="Devices" />}

      <MenuItem to="/customers" icon={<IconCustomers />} label="Customers" />

      {!isTechnician && (
        <MenuItem
          to="/orders"
          icon={<IconOrders />}
          label="Orders"
          badge={<MenuBadge count={data?.data?.quantity} />}
        />
      )}

      {!isTechnician && <MenuItem to="/messages" icon={<IconMessages />} label="Messages" />}

      <MenuItem to="/alerts" icon={<IconAlerts />} label="Alerts" />

      {!isTechnician && (
        <MenuItem to="/perf-test" icon={<IconPerformance />} label="Performance Test" iconType="stroke" />
      )}

      <MenuItem to="/monitoring" icon={<IconMonitoring />} label="Monitoring" />

      <MenuItem to="/intelligence-reports" icon={<IconIntelligenceReports />} label="Intelligence Reporting" beta />
    </>
  )
}
